<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h2 class="headline">
          Configuraciones chat center
        </h2>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="position-relative">
          <v-card tile>
            <v-card-text class="pa-0">
              <v-tabs
                grow
                color="transparent"
                class="border-top border-bottom"
                v-model="tab">
                <v-tabs-slider color="k-orange-linear"></v-tabs-slider>
                <v-tab href="#tab-1"  v-if="user.role !== 'agent'">
                  <v-icon small class="k-orange-linear-text mr-1">fa-cogs</v-icon> <small>Configuraciones</small>
                </v-tab>
                <v-tab href="#tab-2" v-if="user.role !== 'agent'">
                  <v-icon small class="k-orange-linear-text mr-1">fa-code-branch</v-icon> <small>Canales</small>
                </v-tab>
                <v-tab href="#tab-3" v-if="user.role !== 'agent'">
                  <v-icon small class="k-orange-linear-text mr-1">fa-clipboard-list</v-icon> <small>Categorías</small>
                </v-tab>
                <v-tab href="#tab-4" v-if="user.role !== 'agent'">
                  <v-icon small class="k-orange-linear-text mr-1">fa-envelope</v-icon> <small>Reenvio de emails</small>
                </v-tab>
                <v-tab href="#tab-5" v-if="user.role !== 'agent'">
                  <v-icon small class="k-orange-linear-text mr-1">fa-comments</v-icon> <small>Respuestas</small>
                </v-tab>
                <v-tab href="#tab-6">
                  <v-icon small class="k-orange-linear-text mr-1">fa-signature</v-icon> <small>Firma de email</small>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item id="tab-1" v-if="user.role !== 'agent'">
                  <chat-center-config :tab="tab" v-bind.sync="snackbar">
                  </chat-center-config>
                </v-tab-item>
                <v-tab-item id="tab-2" v-if="user.role !== 'agent'">
                  <chat-center-channels v-bind.sync="snackbar">
                  </chat-center-channels>
                </v-tab-item>
                <v-tab-item id="tab-3" v-if="user.role !== 'agent'">
                  <chat-center-categories>
                  </chat-center-categories>
                </v-tab-item>
                <v-tab-item id="tab-4" v-if="user.role !== 'agent'">
                  <forwardings>
                  </forwardings>
                </v-tab-item>
                <v-tab-item id="tab-5" v-if="user.role !== 'agent'">
                  <answer-templates>
                  </answer-templates>
                </v-tab-item>
                <v-tab-item id="tab-6">
                  <signature :user="user" v-bind.sync="snackbar">
                  </signature>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </div>
        <v-snackbar
          :color="snackbar.color || 'success'"
          :timeout="6000"
          :top="true"
          :right="true"
          v-model="snackbar.model">
          {{ snackbar.msg }}
          <v-btn flat color="light" @click.native="snackbar.model = false">Cerrar</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */
import moment from 'moment';
import Forwardings from './Forwardings';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ChatCenterCategories from './ChatCategories';
import ChatCenterChannels from './ChatCenterChannels';
import ChatCenterConfig from './ChatCenterConfig';
import AnswerTemplates from './AnswerTemplates';
import Signature from './Signature';

export default {
  components: {
    Forwardings,
    ChatCenterCategories,
    VuePerfectScrollbar,
    ChatCenterChannels,
    ChatCenterConfig,
    AnswerTemplates,
    Signature,
  },
  data() {
    return {
      tab: '',
      snackbar: {
        msg: '',
        model: false,
        color: 'success',
      },
    };
  },
  computed: {
    user() {
      return this.$auth.user();
    },
  },
};
</script>
<style scoped>
  .border-top {
    border-top: 1px solid #d3d3d3;
  }
  .border-left {
    border-left: 1px solid #d3d3d3;
  }
  .border-bottom {
    border-bottom: 1px solid #d3d3d3;
  }
  .tabs__div:not(:last-child) {
    border-right: 1px solid #d3d3d3;
  }
  .position-relative {
    position: relative;
  }
  .position-absolute {
    position: absolute;
  }
  .btn-close-container {
    z-index: 1;
    top: -25px;
    right: -25px;
    position: absolute;
  }
  .btn-close-container  >>> .btn__content {
    border: 3px solid #f57a63;
  }
</style>




// WEBPACK FOOTER //
// src/components/chat_center_v2/config/Index.vue